<template>
  <v-list dense nav   class="py-1 rounded-lg">
    <v-list-item @click="routerPush(userData.uid)" class="pa-0 ma-0 ps-2 pe-5">
      <v-list-item-content>
        <v-list-item-title class="text-uppercase">
          {{ userData.uname || userData.username }}</v-list-item-title
        >
        <v-list-item-subtitle>{{ userData.role }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action @click="logoutUser">
        <v-icon size="24">
          {{ icons.mdiLogout }}
        </v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-list-item
      v-if="$ability.can('read', 'asl-limit') && !$vuetify.breakpoint.mdAndUp"
      class="initial"
      :class="
        showLimitLoading
          ? 'primary'
          : $store.state.riskDur == 0
          ? 'success'
          : 'tertiary'
      "
    >
      <v-list-item-avatar>
        <v-avatar class="primary--text">
          <v-icon color="white" size="32">
            {{ icons.mdiFinance }}
          </v-icon>
        </v-avatar>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-subtitle
          class="text-caption"
          style="color: white !important"
          >Kalan Limit</v-list-item-subtitle
        >
        <v-list-item-title
          class="text-uppercase text-overline font-weight-bold"
          style="color: white !important"
        >
          <span v-if="showLimitLoading" class="text-caption"
            >Yükleniyor</span
          >
          <span v-else-if="clickLimitStatus" class="text-caption"
            >Güncelleniyor</span
          >
          <span v-else class="text-caption">{{
            $store.state.riskTutar | currency({ fractionCount: 0 })
          }}</span>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action class="ms-0">
        <v-btn icon :loading="clickLimitStatus" @click="clickLimit">
          <v-icon>{{ icons.mdiRefresh }}</v-icon></v-btn
        >
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { computed, getCurrentInstance, ref } from "@vue/composition-api";
import { initialAbility } from "@/plugins/acl/config";
import store from "@/store";
import { useRouter } from "@core/utils";
import {
  mdiAccount,
  mdiLogout,
  mdiAccountCircle,
  mdiShieldAccount,
  mdiFinance,
  mdiRefresh,
  mdiBell,
  mdiTune,
} from "@mdi/js";

export default {
  setup() {
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const { route, router } = useRouter();
    const vm = getCurrentInstance()?.proxy;
    const routerPush = (id) => {
      router.push({ name: "user-view", params: { id } });
    };

    const logoutUser = () => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("userAbility");

      vm.$ability.update(initialAbility);

      router.push({ name: 'auth-login' }).then(() => window.location.reload());
    };

    const clickLimitStatus = ref(false);
    const showLimitLoading = computed(
      () => store.state.riskLoading && route.value.name === "order-to"
    );

    const clickLimit = () => {
      clickLimitStatus.value = true;
      store.dispatch("syncCustomerLimit").finally(() => {
        setTimeout(() => {
          clickLimitStatus.value = false;
        }, 600);
      });
    };

    return {
      clickLimitStatus,
      showLimitLoading,
      clickLimit,
      logoutUser,
      userData,
      routerPush,
      icons: {
        mdiAccount,
        mdiBell,
        mdiLogout,
        mdiShieldAccount,
        mdiTune,
        mdiAccountCircle,
        mdiFinance,
        mdiRefresh,
      },
    };
  },
};
</script>

<style>
.initial {
  height: initial !important;
  min-height: initial !important;
}
</style>
